export default "__VITE_ASSET__C4PQCYZ8__"